module.exports = __webpack_public_path__ + "static/media/PrintScreen.876a2360.png";